import {
  observable,
  computed,
  action,
  useStrict,
  runInAction,
  autorun,
  isObservable,
  isObservableArray,
  isObservableMap
} from "mobx";
import BaseStore from "./BaseStore";
import api from "../api/api";
import utils from "../utils/utils";
import foStorage from "../utils/foStorage";
import zhugeio from "../utils/zhugeio";

useStrict(true);

class StoreMine extends BaseStore {
  constructor() {
    super();
    this.resetData();
  }
  /*
  profileSample = {
    id: "171273",
    name: "17712643539",
    password: "3c881793b52035560188bbd015bd2b82",
    nick_name: "17712643539",
    mobile: "17712643539",
    email: "",
    avatar_url: "/images/avatar_default.png",
    salt: "5a67ed797a3cf",
    coins: 98502,
    present_coins: "0.00",
    points: 0,
    total_points: 0,
    inviter_id: "0",
    total_invite: "0",
    ip: "175.11.169.42",
    token: "171273||c16468ed2bfd85e06e52ac59e3c641d0",
    type: "1",
    level: 0,
    source: "",
    union_id: "",
    uid: "0",
    vip_start: "0000-00-00 00:00:00",
    vip_end: "0000-00-00 00:00:00",
    data: "",
    actor: "0",
    intro: "",
    state: "1",
    platform: "1",
    info:
      '{"p":"1","m":"iPhone 7 Plus","v":"3.1.3","s":"10.3.3","d":"00000000-0000-0000-0000-000000000000","c":"CN","l":"zh"}',
    invite_image_url: "",
    im_token:
      "AkIehvL0NSEODQO3bHNmfB2mLwGomeDwf0z9YB1GCxEmhWb12ZDyQLtAaJA0jMSIsdY3k+/woKOkbDZc7Ytf9w==",
    gender: "0",
    birthday: null,
    signed_at: "2018-01-24 10:20:41",
    logined_at: "2018-02-06 09:08:43",
    created_at: "2018-01-24 10:20:41",
    updated_at: "2018-02-06 16:15:13",
    buy_num: 0,
    used_points: 0,
    message_num: 0,
    coupon_num: 0
  };
  */
  @observable
  profile;
  @observable
  myProfileHome;
  /*
   {
        "step": 5,
        "progress": "80%",
        "gift": {
            "5": 0,
            "15": 0,
            "30": 0
        },
        "points": 0
    }
   */
  @observable
  myInfo;
  /*
gender	N	Int	性别，1男，2女
age_group	N	Int	年龄段 id
industry	N	Int	行业 id
province	N	Int	省 id
city	N	Int	市 id
birthday	N	String	生日 日期格式2019-10-1
company	N	String	单位
job	N	String	职务
wechat	N	String	微信号
   */
  @observable
  myInfoFormData = observable.map({});
  @observable
  myInfoCompleteLoading = false;
  @observable
  myInfoCompleteStepIndex = true;

  @computed
  get ageChoiceList() {
    if (this.myInfo && this.myInfo.configs) {
      return Object.entries(this.myInfo.configs.age_group);
    }
    return [];
  }

  @computed
  get industryChoiceList() {
    if (this.myInfo && this.myInfo.configs) {
      return Object.entries(this.myInfo.configs.industry);
    }
    return [];
  }

  @action.bound
  setMyInfoFormData(k, v) {
    this.myInfoFormData.set(k, v);
  }

  @action.bound
  resetData() {
    this.profile = {
      coins: 0,
      // total_points, used_points, points
      points: 0,
      buy_num: 0
    };
    this.myProfileHome = {};
  }

  @action.bound
  async fetchMyProfile() {
    const {
      data: { data }
    } = await api.getMyProfile();
    if (data) {
      this.mergeMyProfile(data);
    }
  }

  @action.bound
  async fetchMyProfileSafe() {
    // 避免加载profile跳登录, 如果有token, 就去拉profile, 否则不拉
    if (utils.isLogin()) {
      await this.fetchMyProfile();
    } else {
      this.resetData();
    }
  }

  @action.bound
  async fetchMyProfileHome() {
    if (utils.isLogin()) {
      const { _data } = await api.getMyProfileHome();
      if (_data) {
        this.update({
          myProfileHome: _data
        });
      }
    } else {
      this.resetData();
    }
  }

  @action.bound
  mergeMyProfile(profile) {
    if (!profile) {
      return;
    }

    this.profile = Object.assign(utils.ensurePlainJS(this.profile), profile);
    foStorage.setItem(foStorage.KEYS.profile, this.profile);
  }

  @action.bound
  setProfileFromStorage() {
    const profile = foStorage.getItem(foStorage.KEYS.profile);
    this.mergeMyProfile(profile);
  }

  @action.bound
  async initUserProfile() {
    this.setProfileFromStorage();
    await this.fetchMyProfileSafe();
    const profile = this.profile;
    // zhugeio.setIdentity(profile);
  }

  @action.bound
  async fetchMyInfoCompleteProgress() {
    const { _data } = await api.doCompleteMyInfo();
    if (_data) {
      this.update({
        myInfo: _data
      });
    }
  }

  @action.bound
  async doCompleteMyInfo(info = {}) {
    utils.toast.loading("提交中");
    this.update({
      myInfoCompleteLoading: true
    });
    const { _data } = await api.doCompleteMyInfo(info);
    if (_data) {
      const { gift, points } = _data;
      const originProgress = this.myInfo.progress;
      const originStep = this.myInfo.step;
      this.update({
        myInfo: {
          ..._data,
          // progress: originProgress,
          step: originStep
        }
      });
      let timeout = 500;
      if (points > 0) {
        utils.toast.hide();
        utils.toast.success(`+ ${points}积分`);
        timeout = 2000;
      }
      setTimeout(() => {
        utils.toast.hide();
        this.update({
          myInfoCompleteLoading: false
        });
        this.update({
          myInfo: _data
        });
      }, timeout);
    } else {
      utils.toast.hide();
      this.update({
        myInfoCompleteLoading: false
      });
    }
  }
}
export default new StoreMine();



// WEBPACK FOOTER //
// ./src/store/storeMine.js